export default __webpack_public_path__ + "static/media/logo-2.5bb3b58e.svg";